import React from "react";
import { SectionHeading } from "../ui/SectionHeading";
import { OfferSelector } from "./OfferSelector";
export function Plans() {
  return <section id="planes" aria-labelledby="planes-title" className="scroll-mt-20 bg-crema/70 py-14 md:py-20" data-id="element-210" data-mp="13sm21r35fhr7">
      <div className="mx-auto max-w-6xl px-4 md:px-6" data-id="element-211" data-mp="ywx05h3nporq">
        <SectionHeading id="planes-title" eyebrow="Planes" title="Elegí cómo querés estudiar y usar tu japonés." intro="Los tres planes incluyen los siete tomos. Cambia cuánta práctica y cuántas herramientas de consulta sumás." data-id="element-212" data-mp="uuafq19bf64k" />
        <div className="mx-auto mt-8 max-w-2xl md:mt-10" data-id="element-213" data-mp="1htgb8by0tmqx">
          <OfferSelector groupId="principal" data-id="element-214" data-mp="1hrvgal7so1sj" />
        </div>
      </div>
    </section>;
}